export const PageTypeLogin = 1;
export const PageTypeRegister = 2;
export const PageTypeResetPassword = 3;
